import axios from "../../axios";

const getCustomerById = async (id) => {
  try {
    const { data } = await axios.get(`/customers/${id}`);
    return data;
  } catch (e) {
    throw e;
  }
};

const getAppointmentsByCustomer = async (customer_id) => {
  try {
    const { data } = await axios.get(`/appointments/customer/${customer_id}`);
    return data;
  } catch (e) {
    return null;
  }
};

const getAppointmentHistory = async (customer_id) => {
  try {
    const { data } = await axios.get(`/customers/appointment-history/${customer_id}`);
    console.log(data, "appointments");
    return data;
  } catch (e) {
    return null;
  }
};

const findDuplicateByPhone = async (mobile_phone) => {
  try {
    const { data } = await axios.get(`/customers?mobile_phone[$eq]=${mobile_phone}`);
    return data?.rows;
  } catch (e) {
    return null;
  }
};


export { getCustomerById, getAppointmentsByCustomer, getAppointmentHistory, findDuplicateByPhone };